import React, { Component } from 'react'
import moment from 'moment'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import { get } from 'lodash'
import { submitRFPForm, clearFormErrors } from '../../actions/forms'

import DateSelection from './components/DateSelection'
import StateRoomOptions from './components/StateRoomOptions'
import AirArrangements from './components/AirArrangements'
import GuestInfo from './components/GuestInfo'
import AdditionalComments from './components/AdditionalComments'
import '../../styles/scss/components/equote-package-request-details-form.scss'
import '../../styles/scss/components/equote-form-error-modal.scss'
import closeIcon from '../../assets/icons/close.svg'

import ContactInfo from './components/ContactInfo'
import Loyalty from './components/Loyalty'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'
import NameAndLocation from './components/NameAndLocation'

class EQuotePackageAdditionalDetailsForm extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    triggerCustomGaEvent('eQuote-tracking-rfpFormLoaded')
  }

  handleSubmit(values) {
    const stateRoomSelections = values['Choose A Stateroom']

    const stateRoomData = stateRoomSelections
      ? JSON.parse(stateRoomSelections)
      : {}
    const sailDate = get(this.props, 'packageDetails.sailDate', null)
    const reqBody = {
      ...values,
      Date: values.Date ? moment(values.Date).format('MMMM Do YYYY') : null,
      sailDate: sailDate
        ? moment(sailDate, 'YYYY-MM-DD').format('MMMM Do YYYY')
        : null,
      agentEmail: this.props.agentEmail,
      refId: this.props.refId,
      brand: get(this.props, 'packageDetails.brand', ''),
      shipName: get(this.props, 'packageDetails.shipName', ''),
      fareCode: get(stateRoomData, 'fareCode', ''),
      'Choose A Stateroom': `${stateRoomData.categoryCode ||
        ''} ${stateRoomData.sateRoomName || ''}`
    }
    triggerCustomGaEvent('requestSailing-sendRequest', true)
    this.props.onSubmit(reqBody)
  }

  render() {
    const {
      handleSubmit,
      packageDetails,
      selectedDate,
      canUsePromoQualifiers
    } = this.props
    return (
      <div className="equote-package-additional-details-form">
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <p className="equote-package-additional-details-form-heading">
            Complete the form below and an agent will be in touch.
          </p>
          <NameAndLocation
            state
            canUsePromoQualifiers={canUsePromoQualifiers}
          />
          <ContactInfo contactMethod={this.props.contactMethod} />
          <DateSelection
            datesAreFlexible={this.props.datesAreFlexible}
            sailDate={packageDetails.sailDate}
            selectedDate={selectedDate}
          />
          {Boolean(
            this.props.stateRoomOptions && this.props.stateRoomOptions.length
          ) && (
            <StateRoomOptions stateRoomOptions={this.props.stateRoomOptions} />
          )}

          <AirArrangements
            airArrangementsIsRequired={this.props.airArrangementsIsRequired}
          />
          <GuestInfo canUsePromoQualifiers={canUsePromoQualifiers} />
          <Loyalty />
          <AdditionalComments />
          {this.props.submitFailed && (
            <p className="form-has-errors-message">
              One or more required fields is missing. Please check and try
              again.
            </p>
          )}
          <button className="btn btn-primary u-uppercase" type="submit">
            Send Request
          </button>
        </form>
        <ReactModal
          className={{
            base: `equote-form-error-modal u-modal`,
            afterOpen: 'u-modal--visible',
            beforeClose: 'u-modal--close',
            ariaHideApp: false
          }}
          overlayClassName={{
            base: 'u-fade',
            afterOpen: 'u-fade--visible',
            beforeClose: 'u-fade--visible'
          }}
          ariaHideApp={false}
          htmlOpenClassName="ReactModal__Html--open"
          isOpen={this.props.hasErrors}
          onRequestClose={this.props.clearFormErrors}
        >
          <div className="equote-form-error-modal--header">
            <h1 className="equote-form-error-modal--header-title">
              Something Went Wrong
            </h1>
            <button className="btn" onClick={this.props.clearFormErrors}>
              <div className="equote-form-error-modal--header--close-button">
                <span>Close</span>
                <img src={closeIcon} alt="close" />
              </div>
            </button>
          </div>
          <p>We were unable to send your request, please try again.</p>
        </ReactModal>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const contactMethod =
    state.form.EQuotePackageAdditionalDetailsForm &&
    state.form.EQuotePackageAdditionalDetailsForm.values['Contact method']

  const datesAreFlexible =
    state.form.EQuotePackageAdditionalDetailsForm &&
    state.form.EQuotePackageAdditionalDetailsForm.values['Dates are flexible']

  const airArrangementsIsRequired =
    state.form.EQuotePackageAdditionalDetailsForm &&
    state.form.EQuotePackageAdditionalDetailsForm.values[
      'Require Air Arrangements'
    ]

  const selectedDate =
    state.form.EQuotePackageAdditionalDetailsForm &&
    state.form.EQuotePackageAdditionalDetailsForm.values['Date']

  const agentCountry = get(state, 'agencyDetails.agent.country', '')

  const canUsePromoQualifiers =
    agentCountry &&
    ['USA', 'CAN'].some(code => agentCountry.toUpperCase() === code)
  const { packageDetails } = ownProps

  return {
    stateRoomOptions:
      packageDetails &&
      packageDetails.stateRoomData &&
      packageDetails.stateRoomData.selectedStateRooms,
    packageDetails,
    isLoading: state.rfpForm.isLoading,
    hasErrors: state.rfpForm.hasErrors,
    successfullySubmitted: state.rfpForm.successfullySubmitted,
    agentEmail:
      state.agencyDetails.agent && state.agencyDetails.agent.email
        ? state.agencyDetails.agent.email
        : null,
    refId: state.appState.refId,
    alternateDateSelection: state.rfpForm.alternateDateSelection,
    contactMethod,
    datesAreFlexible,
    selectedDate,
    airArrangementsIsRequired,
    canUsePromoQualifiers
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit(reqBody) {
    dispatch(submitRFPForm(reqBody))
  },
  clearFormErrors() {
    dispatch(clearFormErrors())
  }
})

const EQuotePackageAdditionalDetailsFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuotePackageAdditionalDetailsForm)

export default reduxForm({
  form: 'EQuotePackageAdditionalDetailsForm',
  destroyOnUnmount: false
})(EQuotePackageAdditionalDetailsFormContainer)
